import { render, staticRenderFns } from "./daily-nuggets.vue?vue&type=template&id=1ad2e4ec"
import script from "./daily-nuggets.vue?vue&type=script&lang=js"
export * from "./daily-nuggets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports